<template>
  <div>
    <el-form :inline="true" :model="settlementSearchForm" class="user-search" size="mini">
      <!--<el-form-item label="">
        <el-select clearable v-model="selectedOperator" placeholder="选择运营商" @change="selectOperator">
          <el-option
            v-for="item in operators"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            style="width: 175px">
          </el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item>
        <el-cascader ref="cascader" :model="settlementSearchForm" filterable :placeholder="$t('xuan-ze-yun-ying-shang')"
                     :options="operatorsTree"
                     v-model="operatorIds"
                     :show-all-levels="false"
                     :props="{ checkStrictly: true,expandTrigger: 'hover'}" @change="handChangeOperator"></el-cascader>
      </el-form-item>
      <el-form-item >
        <el-select v-model="settlementSearchForm.stationCode" size="mini" :placeholder="$t('qing-xuan-ze-chong-dian-zhan-zhuan-yong-yu-ying-yun-jie-suan-dan-dao-chu')" @change="change" clearable>
          <el-option v-for="item in stationss" :key="item.stationCode" :label="item.stationName" :value="item.stationCode">
            {{item.stationName}}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="settType">
        <el-select size="mini" clearable v-model="settlementSearchForm.settType" :placeholder="$t('jie-suan-lei-xing')">
          <el-option v-for="item in settlementType"
                     :key="item.value"
                     :label="item.message"
                     :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="settlementSearchForm.phone" :placeholder="$t('shou-ji-hao-0')" clearable style="width: 150px"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="settlementSearchForm.orderNo" :placeholder="$t('ding-dan-hao-0')" clearable style="width: 175px"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="settlementSearchForm.settlementNo" :placeholder="$t('jie-suan-dan-hao-0')" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="settlementSearchForm.beginTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('kai-shi-shi-jian')"
                        style="width: 125px">
        </el-date-picker>
        <el-date-picker v-model="settlementSearchForm.endTime"
                        clearable
                        type="date"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('deviceControl.EndTime')"
                        style="width: 125px">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">{{ $t('deviceControl.empty') }}</el-button>
        <el-button type="primary" icon="el-icon-search" @click="searchSettlementReport">{{ $t('deviceControl.search') }}</el-button>
        <el-button v-if="checkPermission(['bee:sett:settlementOrder:report:excel'])" type="primary"
          icon="el-icon-download" @click="exportData">{{ $t('excel-dao-chu') }}</el-button>
          <el-button v-if="checkPermission(['bee:sett:settlementOrder:operationSettlement:excel'])" type="primary"
            icon="el-icon-download" @click="exportOperationSettlement">{{ $t('excel-ying-yun') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :element-loading-text="$t('paramMonitor.Loading')" :data="settlementData" highlight-current-row border
      style="width: 100%;">
      <af-table-column prop="settlementNo" :label="$t('jie-suan-dan-hao-0')">
      </af-table-column>
      <af-table-column prop="operatorId" :label="$t('deviceControl.operatorId')" width="230px">
      </af-table-column>
      <af-table-column prop="orderNo" :label="$t('ding-dan-hao-0')">
      </af-table-column>
      <af-table-column prop="phone" :label="$t('shou-ji-hao-0')" width="130px">
      </af-table-column>
      <af-table-column prop="receAmt" :label="$t('ying-shou-jine-yuan')"width="110px">
      </af-table-column>
      <af-table-column prop="actualAmt" :label="$t('shi-shou-jine-yuan')"width="110px">
      </af-table-column>
      <af-table-column prop="noSettleAmt" :label="$t('wei-jie-qing-jine-yuan')" width="110px">
      </af-table-column>
      <af-table-column prop="takePileAmount"  :label="$t('zhan-zhuang-fei')"  width="110px">
      </af-table-column>
      <af-table-column prop="settType" :label="$t('jie-suan-lei-xing')" width="150px">
      </af-table-column>
      <af-table-column prop="state" :label="$t('shi-fou-que-ren')" width="100px">
      </af-table-column>
      <af-table-column prop="createTime" :label="$t('chuang-jian-shi-jian')">
      </af-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparam" @callFather="getSettlementReport"></Pagination>
  </div>
</template>

<script>
  import Pagination from '@/module/cardManage/component/Pagination.vue'
  import api from '@/module/dataCenter/api/report.js'
  import commonApi from '@/common/api/commonFromVuexApi.js'
  import comApi from '@/common/api/commonApi.js'
  import enumApi from '@/common/api/enumApi.js'
  import configApi from '@/module/resourceCenter/api/meterConfigurationApi'
  export default {
    name: 'list',
    data() {
      return {
        operatorsTree: [],
        operatorIds: [],
        settlementData: [],
        settlementSearchForm: {},
        selectedOperator: '',
        operators: '',
        loading: false,
        stationss: [],
        settlementType: [],

        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },

      }
    },
    components: {
      Pagination
    },
    created() {
      this.loadOperators()
      this.getOperatorTree()
      this.searchSettlementReport()
      this.getSettlementType()
    },
    methods: {
      async getSettlementType() {
        const data = await enumApi.getSettlementTypeEnum()
        this.settlementType = data ? data : []
      },
      getOperatorTree(){
        let params = JSON.stringify({});
        comApi.getOperatorsTree(params).then((res)=>{
          this.operatorsTree = res.data
        })
      },
      handChangeOperator(value) {
        let operatorId = value && value.length > 0 ? value[value.length - 1] : ''

        this.$refs.cascader.dropDownVisible = false
        let par = []
        this.settlementSearchForm.operatorId=value[0]
        if (this.settlementSearchForm.operatorId != null && this.settlementSearchForm.operatorId != '') {
          par.push(this.settlementSearchForm.operatorId);
        }else if(this.settlementSearchForm.operatorId == null){
          this.settlementSearchForm.stationCode=null
        }
        this.stationss=[]
        this.selectedOperator=value[0]
        this.getstationData(par)
      },
      getstationData(param) {
        configApi.alarmStationAll(param).then((res) => {
          console.info(JSON.stringify(res.data))
          this.stationss = res.data
        })
      },
      change() {
        this.$forceUpdate()
      },
      //加载运营商列表
      loadOperators() {
        commonApi.getOperators().then((res) => {
          this.operators = res
        })
      },
      selectOperator() {
        api.stationList([this.selectedOperator]).then((res)=>{
          this.stations = res.data
        })
      },
      resetSearchForm() {
        this.settlementSearchForm = {}
        this.selectedOperator = ''
        this.operatorIds = []
        this.settlementReport()
      },
      searchSettlementReport(){
        this.getSettlementReport()
      },
      settlementReport(param){
        this.loading = true;
        api.getSettlementReport(param).then((res)=>{
          if (res.code === 0) {
            this.pageparam.total = res.data.total
            this.settlementData = res.data.list
            this.loading = false;
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getSettlementReport() {
        this.pageparam.t = {
          operatorId: this.selectedOperator,
          phone: this.settlementSearchForm.phone === undefined ? '' : this.settlementSearchForm.phone,
          beginTime: this.settlementSearchForm.beginTime === undefined ? '' : this.settlementSearchForm.beginTime,
          endTime: this.settlementSearchForm.endTime === undefined ? '' : this.settlementSearchForm.endTime,
          settlementNo: this.settlementSearchForm.settlementNo === undefined ? '' : this.settlementSearchForm.settlementNo,
          orderNo: this.settlementSearchForm.orderNo === undefined ? '' : this.settlementSearchForm.orderNo,
          settType: this.settlementSearchForm.settType === undefined ? '' : this.settlementSearchForm.settType,
        }

        let param = Object.assign({}, this.pageparam)
        this.settlementReport(param)
      },
      async exportData() {
        let flag = false
        if (!this.selectedOperator ||  this.selectedOperator == '' ||
          !this.settlementSearchForm.settType || this.settlementSearchForm.settType == '' ||
          this.settlementSearchForm.beginTime == null || this.settlementSearchForm.endTime == null ||
          this.settlementSearchForm.beginTime == '' || this.settlementSearchForm.endTime == 'min') {
          flag = false
        } else {
          let beginDate = new Date(this.settlementSearchForm.beginTime.substring(0,10))
          let endDate = new Date(this.settlementSearchForm.endTime.substring(0,10))
          let diffYear = endDate.getFullYear()-beginDate.getFullYear()
          let diffMonth = diffYear*12 + endDate.getMonth()-beginDate.getMonth()
          let diffDay = endDate.getDate()-beginDate.getDate()
          if (diffMonth<3 || (diffMonth == 3 && diffDay <=0 )) {
            flag = true
          }
        }
        //结算单
        if (flag) {
          let param = {
            phone: this.settlementSearchForm.phone === undefined ? '' : this.settlementSearchForm.phone,
            operatorId: this.selectedOperator,
            beginTime: this.settlementSearchForm.beginTime === undefined ? '' : this.settlementSearchForm.beginTime,
            endTime: this.settlementSearchForm.endTime === undefined ? '' : this.settlementSearchForm.endTime,
            settlementNo: this.settlementSearchForm.settlementNo === undefined ? '' : this.settlementSearchForm
              .settlementNo,
            orderNo: this.settlementSearchForm.orderNo === undefined ? '' : this.settlementSearchForm.orderNo,
            settType: this.settlementSearchForm.settType === undefined ? '' : this.settlementSearchForm.settType,
          }
          api.downSettlement(param).then((res)=>{
            if (res){
              this.downloadExcel(res,this.$t('jie-suan-dan-1'))
            }
          })
        } else {
          this.$message.error(this.$t('qing-xuan-ze-yun-ying-shang-he-lei-xing-bing-qie-san-ge-yue-zhi-nei-shu-ju'))
        }
      },
      //下载excel,res为要导出的内容，name为文件名
      downloadExcel(res,name) {
        const blob = new Blob([res],{
          type: 'application/vnd.ms-excel;charset=utf-8'
        })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = name+'.xlsx'
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      },
      //营运结算单导出
      exportOperationSettlement(){

        if(this.settlementSearchForm.stationCode==null){
           return  this.$message.error(this.$t('qing-xuan-ze-zhan-dian'))
        }
        if(this.settlementSearchForm.beginTime==null||this.settlementSearchForm.endTime==null){
        return  this.$message.error(this.$t('qing-xuan-ze-kai-shi-shi-jian-yu-jie-shu-shi-jian'))
        }
        let param = {}
        param.operatorId=this.selectedOperator
        param.stationCode=this.settlementSearchForm.stationCode
        param.settlementStart=this.settlementSearchForm.beginTime
        param.settlementEnd =this.settlementSearchForm.endTime
        param.meterStart=this.settlementSearchForm.beginTime
        param.meterEnd=this.settlementSearchForm.endTime
        console.log(param)
        api.downloadOperationSettlement(param).then((res) => {
          if (res) {
            this.downloadExcel(res, this.$t('ying-yun-jie-suan-dan'))
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/baobiao/settlementOrder/list.vue